$.fn.dataTable.ext.search.push(
    function(settings, rowData, rowIndex) {
        if (typeof settings.oInit.search.date == 'undefined') {
            return true;
        }

        let returnValue = true;
        $.each(settings.oInit.search.date, function (index, column) {
            if (!returnValue || (typeof column.minFilterElement === 'undefined'
                && typeof column.maxFilterElement === 'undefined' && typeof column.filterElement === 'undefined')) {
                // this row is already marked as "do not show" or settings are invalid
                return;
            }

            // get rid of additional content in the date column
            let cellDate = $("<div>").html(rowData[column.columnIndex]).text().trim().split(" ");
            cellDate = cellDate[0];
            cellDate = moment(cellDate, column.cellFormat);

            if (typeof column.filterElement !== 'undefined') {
                let $weekFilterElement = column.filterElement;
                let weekFilterDate = moment($weekFilterElement.val(), column.filterFormat);

                returnValue = !weekFilterDate.isValid() || !cellDate.isValid() || (
                    cellDate.isSame(weekFilterDate, 'week') && cellDate.isSame(weekFilterDate, 'week')
                );
            } else {
                let $minFilterElement = column.minFilterElement;
                let $maxFilterElement = column.maxFilterElement;
                let minFilterDate = moment($minFilterElement.val(), column.filterFormat);
                let maxFilterDate = moment($maxFilterElement.val(), column.filterFormat);

                if (minFilterDate.isValid() && maxFilterDate.isValid() && cellDate.isValid()) {
                    returnValue = cellDate.isSameOrAfter(minFilterDate, 'day') && cellDate.isSameOrBefore(maxFilterDate, 'day');
                } else if (minFilterDate.isValid() && cellDate.isValid()) {
                    returnValue = cellDate.isSameOrAfter(minFilterDate, 'day');
                } else if (maxFilterDate.isValid() && cellDate.isValid()) {
                    returnValue = cellDate.isSameOrBefore(maxFilterDate, 'day');
                } else {
                    returnValue = true;
                }
            }
        });

        return returnValue;
    }
);
